export default __webpack_public_path__ + "static/media/logoWithText.986f23fe.svg";